import { Component, OnInit } from '@angular/core';
import { UserConfigService, LoggingUser } from 'src/app/shared/services/user-config.service';
import { ProspectsService } from 'src/app/shared/services/prospects.service';

@Component({
  selector: 'app-prospect-dashboard',
  templateUrl: './prospect-dashboard.component.html',
  styleUrls: ['./prospect-dashboard.component.scss']
})
export class ProspectDashboardComponent implements OnInit {
  userId: number = 0;
  userTags: any = {};

  // Chart access codes (unchanged)
  chartCodes = {
    prospectSummary: 'smry_ch_main',
    customerProspectSummary: 'smry_ch_cstmr',
    prospectActivitySummary: 'smry_ch_actvty',
    monthlyProspectsOverview: 'smry_ch_month',
    BrandProspectSummary: 'smry_ch_brand',
  };

  constructor(
    private userConfigService: UserConfigService,
    private prospectsService: ProspectsService
  ) {}

  ngOnInit() {
    this.getLoggedInUserAndLoadTags();
  }

  getLoggedInUserAndLoadTags() {
    this.userConfigService.getLoggingUser().subscribe(
      (user: LoggingUser) => {
        if (user && user.id !== undefined) {
          this.userId = user.id;
        } else {
          this.userId = 0; // fallback for admin
        }
        this.loadUserTags();
      },
      error => {
        console.error('Error getting logged-in user:', error);
        this.userId = 0;
        this.loadUserTags();
      }
    );
  }

  loadUserTags() {
    this.prospectsService.getUserTags(this.userId).subscribe(
      response => {
        this.userTags = response;
      },
      error => {
        console.error('Error loading user tags for user ID:', this.userId, error);
      }
    );
  }

  hasChartAccess(chartCode: string): boolean {
    if (!this.userTags?.prospectCharts?.length) return false;
    return this.userTags.prospectCharts.some((tag: any) => tag.uniqueCode === chartCode);
  }
}